<template>
  <!-- Modal -->
  <div
    class="modal fade"
    ref="vuemodal"
    id="returnDownloadFilesModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-large">
      <div class="modal-content">
        <vue-element-loading
          :active="isSearching"
          spinner="bar-fade-scale"
          color="#333"
        />
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">ファイル一覧</h5>
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <v-data-table
            class="table table-striped"
            item-key="id"
            :headers="headers"
            :items="files"
            hide-default-footer
            hide-default-header
            disable-pagination
            height="400"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th v-for="(h, i) in headers" :class="h.class" :key="i">
                  <span>{{h.text}}</span>
                </th>
              </tr>
            </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody class="nowrap">
                <tr v-show="!items.length">
                  <td>本日のアップデータはありません。よろしくお願いします。</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr v-for="(file, i) in items" :key="i" >
                  <td><a class="text-elip" :href="$api_url.view_file.origin+file.file_path" target="_blank" rel="noopener noreferrer">{{file.file_name}}</a></td>
                  <td>{{file.created_at}}</td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      type="button"
                      @click="deleteEvident(file)"
                    >
                      削除
                    </button>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button
            ref="closeModal"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import _ from 'lodash'

export default {
  name: 'ShippingDownloadFilesModal',
  components: {
    VueElementLoading
  },
  methods: {
    setFiles (files) {
      this.files = files
    },
    deleteEvident (file) {
      this.$dialog.confirm('本当に削除しますか?').then(async () => {
        try {
          const formData = new FormData()
          formData.append('id', file.id)
          this.$http.post(this.$api_url.return_delete_evident, formData).then(response => {
            const result = response.data
            if (!result || result.status !== true) {
              this.$toastr.error('エラーが発生しました。' + result.message, 'エラー')
            } else {
              let indexRemove = _.findIndex(this.files, function (o) { return o.id === file.id })
              this.files.splice(indexRemove, 1)
              this.$parent.setEvidentFileDelete(this.files)
              this.$toastr.success('返品データを削除しました。', 'Success')
            }
          }).catch(err => {
            this.$toastr.error('エラーが発生しました。' + err.message, 'エラー')
          }).finally(() => {
            this.isLoading = false
            this.evidentFile = []
          })
        } catch (error) {
          console.log('SingleReturn:deleteReturn:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    }
  },
  data () {
    return {
      isSearching: false,
      headers: [
        { text: 'ファイル名', sortable: false },
        { text: 'アップロード日', sortable: false },
        { text: '', sortable: false }
      ],
      files: []
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 700px;
}
a.text-elip {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 278px;
}

.table thead th span {
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>
